export interface FindAllUsersResponseDTO {
    total: number
    page: number
    perPage: number
    prev: boolean
    next: boolean
    totalPage: number
    users: UserDTO[]
}

export enum Roles {
    ADMIN = 1,
    OPERATOR = 2
}

export interface UserDTO {
    username: string
    name: string
    surname: string
    email: string
    role: Roles | null
    userId: string
    id: string | number
    company: string
}

export interface UserFiltersDTO {
    itemsPerPage: number
    order: boolean
    page: number
    sort: string
    name: string
}

export interface CreateUserRequestDTO {
    name: string
    surname: string
    email: string
    role: Roles | null
    username: string
    company: string
}

export interface EditUserRequestDTO {
    name: string
    surname: string
    username: string
    company: string
}

export interface UserInfoDTO {
    name: string,
    surname: string,
    role: string,
    mail: string,
    avatarObjectId: string | null,
    userId: string,
    businessName?: string
}